module.exports = __webpack_public_path__ + "russierenouvelables/img/diesel-generators.c37ff22d.webp";